export const KANBAN_COLUNAS = [
  { id: 'CADASTRADO', label: 'Cadastrado', color: 'bg-slate-100  text-slate-600  border-slate-300'  },
  { id: 'FABRICANDO', label: 'Fabricando', color: 'bg-amber-100  text-amber-700  border-amber-300'  },
  { id: 'EXPEDICAO',  label: 'Expedição',  color: 'bg-green-100  text-green-700  border-green-300'  },
  { id: 'ROTA',       label: 'Rota',       color: 'bg-orange-100 text-orange-700 border-orange-300' },
  { id: 'ENTREGUE',   label: 'Entregue',   color: 'bg-pink-100   text-pink-700   border-pink-300'   },
  { id: 'AJUSTE',     label: 'Ajuste',     color: 'bg-blue-100   text-blue-700   border-blue-300'   },
]

export const STATUS_DEFAULT = 'CADASTRADO'

export const CIDADES_ABAS = [
  { id: 'TODAS',  label: 'Todos',          cidades: null },
  { id: 'JP',     label: 'João Pessoa',    cidades: ['joao pessoa','jp','bayeux','santa rita','cabedelo','bananeiras','alhandra','conde','lucena','rio tinto','mamanguape','sape','pilar','itabaiana','pedras de fogo'] },
  { id: 'CG',     label: 'Campina Grande', cidades: ['campina grande'] },
  { id: 'NATAL',  label: 'Natal',          cidades: ['natal','parnamirim','extremoz','sao goncalo do amarante','sao goncalo','macaiba'] },
  { id: 'RECIFE', label: 'Recife',         cidades: ['recife','olinda','jaboatao','paulista','cabo de santo agostinho','cabo','igarassu','camaragibe','abreu e lima','itamaraca','itapissuma','sao lourenco da mata','moreno','ipojuca'] },
]

function normCidade(str) {
  return (str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()
}

// Busca em qual aba o texto bate. Retorna id da aba ou null.
function buscarAba(texto) {
  if (!texto) return null
  for (const aba of CIDADES_ABAS) {
    if (!aba.cidades) continue
    if (aba.cidades.some(c => texto.includes(c))) return aba.id
  }
  return null
}

// Detecta a cidade da aba em ordem de prioridade. Pedidos do Bling
// frequentemente t\u00eam `cliente.cidade` vazio, mas a info t\u00e1 no bairro
// ("Torre - Jo\u00e3o Pessoa") ou no endere\u00e7o. A ordem evita falso positivo
// (ex: "Av. Recife" numa rua de Jo\u00e3o Pessoa).
export function detectarCidadeAba(pedido) {
  // 1. Campo cidade \u2014 autoridade m\u00e1xima
  const cidade = normCidade(pedido.cliente?.cidade)
  let r = buscarAba(cidade)
  if (r) return r

  // 2. Bairro \u2014 campo edit\u00e1vel da Log\u00edstica OU bairro do cliente
  //    Comum em pedidos do Bling: "Torre - Jo\u00e3o Pessoa"
  const bairro = normCidade(pedido.bairro || pedido.cliente?.bairro)
  r = buscarAba(bairro)
  if (r) return r

  // 3. Endere\u00e7o completo \u2014 \u00faltimo fallback. Pode dar falso positivo
  //    (ex: "Rua Pessoa" em outra cidade), mas \u00e9 melhor que nada.
  const endereco = normCidade(pedido.cliente?.endereco)
  r = buscarAba(endereco)
  if (r) return r

  return 'OUTRAS'
}
